import type { ReactNode } from 'react';

export const symbol_ripples: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-180h600v-371q-21 13-45.14 19-24.13 6-48.86 6-66.83 0-114.41-47.59Q524-621.17 524-688q0-24.05 6-47.52Q536-759 549-780H180v600Zm0 60q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-660v600-600Z"
		/>
	</svg>
);
